import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const stockInfoApi = createApi({
    reducerPath: "stockInfoApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getStockInfo: builder.query({
            query: () => ({
                url: "/Product/all-product-for-stock-info",
                method: "GET",
            }),
        }),
    }),
});

export const { useGetStockInfoQuery } = stockInfoApi;
